import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import { MessageConditionAutoResponse } from '../../types'

function useQueryGetAutoMessageConditions(
	props?: UseBaseQueryOptions<MessageConditionAutoResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetMessageConditionsAuto],
		queryFn: () => MessagingService.getMessageConditionsAuto(),
		...props,
	})
}

export default useQueryGetAutoMessageConditions
